import { render } from "./operationManual2.vue?vue&type=template&id=57565084&scoped=true"
import script from "./operationManual2.vue?vue&type=script&lang=js"
export * from "./operationManual2.vue?vue&type=script&lang=js"

import "./operationManual2.vue?vue&type=style&index=0&id=57565084&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57565084"

export default script